import { validate, ValidationError as Error } from "class-validator";

import { property } from '../data.service';
import { BookemZulu as Model, $data } from './JayDataContext';

export class EntityModel<TEntity extends $data.Entity, TViewModel extends Model> {
	constructor(public entity: TEntity) {
		entity.propertyChanged.attach(this.validateProperty);
	}

	@property<TViewModel>(o => o.entity.isDeleted, (o, value) => o.entity.isDeleted = value)
	public isDeleted: boolean;

	public async validateDynamicProperty(jsonSchema: string, dynamicProperties: any, property?: string): Promise<ValidationError[]> {
		const errors = await validate(jsonSchema, dynamicProperties, { skipMissingProperties: true });
		const result: ValidationError[] = [];
		for (const error of errors) {
			if (property != null) {
				if (error.property == property) {
					for (const validation in error.constraints) {
						var messages = error.constraints[validation].split('<br />');
						if (messages != null) {
							for (let msg of messages)
								result.push({
									property: error.property,
									text: msg
								});
						} else {
							result.push({
								property: error.property,
								text: error.constraints[validation]
							});
						}

					}
					break;
				}
			}
			else {
				for (const validation in error.constraints) {
					result.push({
						property: error.property,
						text: error.constraints[validation]
					});
				}
			}

		}
		return result;
	}
	public async validate(validateChildren: boolean, property?: string): Promise<ValidationError[]> {
		const errors = await validate(this, { skipMissingProperties: true });
		return this.processErrors(validateChildren, errors, property);
	}

	private processErrors(validateChildren: boolean, errors: Error[], property?: string) {
		let result: ValidationError[] = [];
		for (const error of errors) {
			if (property != null && error.property != property) {
				continue;
			}
			for (const validation in error.constraints) {
				var messages = error.constraints[validation].split('<br />');
				if (messages != null) {
					for (let msg of messages)
						result.push({
							property: error.property,
							text: msg
						});
				} else {
					result.push({
						property: error.property,
						text: error.constraints[validation]
					});
				}
			}
			if (validateChildren && error.children && error.children.length > 0) {
				result = result.concat(this.processErrors(validateChildren, error.children, property));
			}
		}
		return result;
	}

	protected validateProperty(sender: any, event: any) {
	}
}



// WEBPACK FOOTER //
// ./src/core/services/data/models.ts